import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from './../../../../../Containers/Config/index';
import { GET_CAMPAIGNS, GET_CAMPAIGNS_SUCCESS, GET_CAMPAIGNS_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getCampaigns({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/campaign`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAMPAIGNS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAMPAIGNS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAMPAIGNS_ERROR, payload: error });
  }
}

export function* watchGetCampaigns() {
  yield takeEvery(GET_CAMPAIGNS, getCampaigns);
}

function* getCampaignsSaga() {
  yield all([fork(watchGetCampaigns)]);
}

export default getCampaignsSaga;
